import { $, _, Backbone, Marionette } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";

import PricediscountsAccessBarTpl from "../../templates/pricediscounts/PricediscountsAccessBarTpl.html";

export default InboomaBaseView.extend({
  el: "#inb-c-main-access-bar",
  template: PricediscountsAccessBarTpl,

  ui: {
    searchField: "#inb-c-main-access-bar__search .inb-input--search",
    selectViewType: ".inb-hor-icon-nav",
  },

  events: {
    "keyup @ui.searchField": "_filterQuery",
    "click @ui.selectViewType li": "_changeViewType",
  },

  _changeViewType(el) {
    el = $(el.currentTarget);
    this.getUI("selectViewType").find("li.active").removeClass("active");
    el.addClass("active");
  },

  _filterQuery() {
    const query = this.getUI(".discount_type").attr("data-inb-val");

    //this.getUI('searchField').parent().find('.inb-input--search-reset').fadeIn('fast');

    if (query.length >= 1) this.collection.filterByType(query);
    else if (query.length === 0) this.collection.removeFilter("query");
  },
});
